
<template>
  <AppCore
    appName="ecommerce"
    :onlyLanguage="false"
    :summaryBehavior="$store.state.systemStore.summaryBehavior"
    @config-ready="loadApi"
  ></AppCore>
</template>
<script>
import Vue from 'vue'
import api from './plugins/api'
export default {
  name: 'spa',
  components: {
    AppCore: () => import(/* webpackChunkName: "app-core" */'core/components/AppCore')
  },
  mounted () {
    this.handleBrowserTab()
    this.setCustomPathList()
  },
  methods: {
    loadApi () {
      Vue.use(api(this.$store.getters.getConfigUrls))
    },
    handleBrowserTab () {
      const navTab = (window.performance.getEntriesByType('navigation')[0]).type
      if (navTab === 'back_forward' && !window.name) {
        this.$router.push('session-error')
      } else {
        window.name = this.$store.getters.getSessionId
      }
    },
    setCustomPathList () {
      // cuando hace back desde navegador, se pierde el path
      this.$store.commit('setPathList', [window.location.pathname])
    }
  }
}
</script>

<style lang="sass">
main
  padding: 1rem 1rem 3rem
@media (min-width: 992px)
  main
    padding: 1.5rem 1rem 5rem
</style>
